import React, { useEffect, useMemo, useState } from 'react';
import { Box, Typography } from 'components/mui';
import { Paper } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectUserInfo } from 'redux/userInfo/userInfoSlice';
import useComments from 'containers/pages/comments/hooks/useComments';
import CaseCommentManager from 'containers/pages/comments/components/caseTable/CaseCommentManager';
import CaseCommentsTable from 'containers/pages/comments/components/caseTable/CaseCommentsTable';
import { CANtrackComment } from 'containers/pages/comments/types/comment';

function DashboardTimesheets() {
  const { userInfo } = useSelector(selectUserInfo) as any;
  const employeeId = userInfo?.employeeId ?? '';
  const userId = userInfo?.userId ?? '';
  const contactId = userInfo?.contactId ?? '';

  const {
    comments,
    loadingComments,
    setComments,
    fetchComments,
  } = useComments();

  const [commentToCopy, setCommentToCopy] = useState<CANtrackComment>();
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (employeeId) {
      const loadComments = async () => {
        try {
          await fetchComments({ employeeId, date: new Date() });
        } catch (error) {
          console.error('[DashboardTimesheets] Failed to load timesheet:', error);
        }
      };
      loadComments();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeId]);

  const filteredComments = useMemo(() => {
    if (!searchTerm.trim()) return comments;
    const term = searchTerm.trim().toLowerCase();
    return comments.filter(
      (c) =>
        c.customerName?.toLowerCase().includes(term) ||
        c.caseTitle?.toLowerCase().includes(term) ||
        c.title?.toLowerCase().includes(term) ||
        c.description?.toLowerCase().includes(term),
    );
  }, [comments, searchTerm]);

  const handleCopyComment = (comment: CANtrackComment) => {
    setCommentToCopy({ ...comment, id: 0 });
  };

  return (
    <Paper variant="outlined" sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
        Today's Timesheet
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
        <CaseCommentManager
          setComments={setComments}
          commentToCopy={commentToCopy}
          resetCommentToCopy={() => setCommentToCopy(undefined)}
          userId={userId}
          contactId={contactId}
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
        />
        <CaseCommentsTable
          comments={filteredComments}
          loadingComments={loadingComments}
          showDecimalFormat={true}
          setComments={setComments}
          onCopyCommentClick={handleCopyComment}
          hideCaseInfo
        />
      </Box>
    </Paper>
  );
}

export default DashboardTimesheets;
